import React, { FunctionComponent, Ref, useMemo } from 'react';

import { ChevronOffsetRight } from '@yandex-360/iconostasis/dist/icons/ChevronOffsetRight';
import { Tick } from '@yandex-360/iconostasis/dist/icons/Tick';
import { ListBox } from '@yandex-360/orb-components/dist/components/ListBox';
import { ListBoxItem, ListBoxItemProps } from '@yandex-360/orb-components/dist/components/ListBoxItem';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { DATE_RANGE_TYPE } from '../../../../constants';
import { getRangeTypeLabelMap } from '../../../../helpers/get-range-type-label-map';
import { useIsMobileOneColLayout } from '../../../../hooks';
import { selectDateRangeType } from '../../../../selectors';
import styles from './styles.css';

type RangeTypeListBoxProps = {
    onDateRangeTypeSelected: (item: ListBoxItemProps<DATE_RANGE_TYPE>) => void;
    toggleIsMonthFilterOpen: () => void;
    specificMonthRef?: Ref<HTMLLIElement>;
};
export const RangeTypeListBox: FunctionComponent<RangeTypeListBoxProps> = ({
    onDateRangeTypeSelected,
    toggleIsMonthFilterOpen,
    specificMonthRef,
}) => {
    const dateRangeTypeLabelMap = useMemo(getRangeTypeLabelMap, []);
    const dateRangeType = useSelector(selectDateRangeType);
    const isOneColLayout = useIsMobileOneColLayout();
    return (
        <ListBox className={cn({ [styles.oneColLayout]: isOneColLayout })}>
            <ListBoxItem
                itemKey={DATE_RANGE_TYPE.FOR_3_MONTH}
                label={dateRangeTypeLabelMap[DATE_RANGE_TYPE.FOR_3_MONTH]}
                isSelected={dateRangeType === DATE_RANGE_TYPE.FOR_3_MONTH}
                onItemSelect={onDateRangeTypeSelected}
            />
            <ListBoxItem
                ref={specificMonthRef}
                itemKey={DATE_RANGE_TYPE.SPECIFIC_MONTH}
                label={dateRangeTypeLabelMap[DATE_RANGE_TYPE.SPECIFIC_MONTH]}
                onItemSelect={toggleIsMonthFilterOpen}
                endSlot={
                    !isOneColLayout ? (
                        <ChevronOffsetRight variant="outline" size="sm" />
                    ) : dateRangeType === DATE_RANGE_TYPE.SPECIFIC_MONTH ? (
                        <Tick variant="outline" size="sm" />
                    ) : undefined
                }
            />
            <ListBoxItem
                itemKey={DATE_RANGE_TYPE.SPECIFIC_DATES}
                label={dateRangeTypeLabelMap[DATE_RANGE_TYPE.SPECIFIC_DATES]}
                isSelected={dateRangeType === DATE_RANGE_TYPE.SPECIFIC_DATES}
                onItemSelect={onDateRangeTypeSelected}
            />
            <ListBoxItem
                itemKey={DATE_RANGE_TYPE.SPECIFIC_DATE}
                label={dateRangeTypeLabelMap[DATE_RANGE_TYPE.SPECIFIC_DATE]}
                isSelected={dateRangeType === DATE_RANGE_TYPE.SPECIFIC_DATE}
                onItemSelect={onDateRangeTypeSelected}
            />
        </ListBox>
    );
};
